import { getScrollPosition } from "@montana/helpers/on-scroll.helper";

const className = "scroll-lock";
let scrollTop = 0;


export let isScrollLocked = false;


export function enableScrollLock(): void {
    if (!isScrollLocked) {
        // Get scroll position
        const scrollPosition = getScrollPosition();

        // Reset scroll position
        window.scrollTo(scrollPosition.x, 0);

        const htmlTag = document.documentElement;
        htmlTag.classList.add(className);
        htmlTag.style.marginTop = `${-scrollPosition.y}px`;
        htmlTag.style.position = "fixed";
        htmlTag.style.width = "100%";

        // Remember state
        isScrollLocked = true;
        scrollTop = scrollPosition.y;
    }
}


export function disableScrollLock(): void {
    if (isScrollLocked) {
        const scrollPosition = getScrollPosition();

        const htmlTag = document.documentElement;
        htmlTag.classList.remove(className);
        htmlTag.style.marginTop = "";
        htmlTag.style.position = "";
        htmlTag.style.width = "";

        // Set the scroll position to what it was before
        window.scrollTo(scrollPosition.x, scrollTop);

        // Remember state
        isScrollLocked = false;
    }
}


export function toggleScrollLock(): void {
    if (isScrollLocked) {
        disableScrollLock();
    } else {
        enableScrollLock();
    }
}
